<script>
import Widget from "../../Widget.vue";
import DatePicker from "../../DatePicker.vue";
import MargettsApi from "../../../modules/margetts-api";
import { useSearchableSelector } from '../../../composables/useSearchableSelector'
import {nextTick} from "vue";

export default {
    name: "InvestorDetails",
    components: {DatePicker},
    extends: Widget,
    props: ["newInvestorFlag", "applicationFormValues"],
    emits: ["emitInvestorDetails", "isLoading", "update:model-value"],
    data() {
        return {
            investorDetails: { ...this.applicationFormValues?.investorDetails },
            countryList: [],
        }
    },

    created() {
        this.render();
    },

    methods: {
        render () {
            this.fetchCountryLists();
        },

        next() {
            this.investorDetails = { page: 4, investorDetails: {...this.investorDetails} }

            this.updateInvestor();
            this.$emit('emitInvestorDetails', this.investorDetails)
        },

        previous() {
            this.investorDetails = { page: 2 }
            this.$emit('emitInvestorDetails', this.investorDetails)
        },

        updateInvestor() {
            this.$emit("isLoading", true);

            if (this.investorDetails.investorDetails.hasOwnProperty('country')) {
                const [country, country_code] = this.investorDetails.investorDetails.country.split(',');
                this.investorDetails.investorDetails.country = country;
                this.investorDetails.investorDetails.country_code = country_code;
            }

            const data = {
                'application_id': this.applicationFormValues.applicationFormID,
                user: 'userId',
                ...this.investorDetails.investorDetails
            };

            MargettsApi.post('investment-application/investor', this.createQueryStringFromParameters(data, false), response => {
                if ( ! response || ! response.result) {
                    return MargettsApi.throwNoResponseError();
                }

                if (response.result !== 'success') {
                    return this.throwApiError(response.messages);
                }

                if (response.messages) {
                    flash(response.messages.join('<br>'), 'success');
                }
            }).catch(error => {
                MargettsApi.throwError(error);
            });

            this.$emit("isLoading", false);
        },

        async fetchCountryLists() {
            this.$emit('isLoading', true);
            try {
                if (this.countryList.length === 0) {
                    const { data } = await axios.get('investment-application/country-lists');
                    let responseData = data;
                    if ( ! responseData || ! responseData.result) {
                        return MargettsApi.throwNoResponseError();
                    }

                    if (responseData.result !== 'success') {
                        return this.throwApiError(responseData.messages);
                    }

                    this.countryList = responseData.data;
                }

                const { initSearchableSelector } = useSearchableSelector()
                await nextTick()
                if (this.newInvestorFlag) {
                    initSearchableSelector("countryList").enable();
                } else {
                    initSearchableSelector("countryList").disable();
                }
            } catch(error) {
                MargettsApi.throwError(error);
            }
            this.$emit("isLoading", false);
        },

        HandleDateChange(date) {
            if (!date) return;

            const dateString = this.formatDate(date);
            this.investorDetails.date_of_birth = dateString;
            this.$emit('update:model-value', dateString);
        },

        formatDate(date) {
            const dateString = new Date(date);
            return dateString.toLocaleDateString('en-gb')
        }
    }
}
</script>

<template>
    <section>
        <p v-if="! newInvestorFlag" class="alert alert-info">
            This section is read-only. Please review and confirm the details below before proceeding with the form.
        </p>

        <form @submit.prevent="next()">
            <div v-if="! newInvestorFlag" class="form-group">
                <label for="name">
                    Investor Code
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="code"
                    :required="newInvestorFlag"
                    value=""
                    v-model="investorDetails.code"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>

            <div class="form-group ">
                <label for="name">
                    Name
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="name"
                    :required="newInvestorFlag"
                    value=""
                    v-model="investorDetails.name"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>

            <div class="form-group ">
                <label for="dob">
                    Date of birth
                </label>

                <DatePicker
                    id="date"
                    name="date"
                    class="form-control"
                    :value="investorDetails.date_of_birth?.toString() ?? ''"
                    @update:model-value="HandleDateChange"
                    :is-required="newInvestorFlag"
                    :is-disabled="!newInvestorFlag"
                />
            </div>

            <div class="form-group ">
                <label for="address">
                    Address 1
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="address_1"
                    value=""
                    :required="newInvestorFlag"
                    v-model="investorDetails.address_1"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>

            <div class="form-group">
                <label for="address">
                    Address 2
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="address_2"
                    value=""
                    :required="newInvestorFlag"
                    v-model="investorDetails.address_2"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>

            <div class="form-group ">
                <label for="address">
                    Address 3
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="address_3"
                    value=""
                    :required="newInvestorFlag"
                    v-model="investorDetails.address_3"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>

            <div v-if="! newInvestorFlag" class="form-group ">
                <label for="address">
                    Address 4
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="address_4"
                    value=""
                    v-model="investorDetails.address_4"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>


            <div v-if="newInvestorFlag" class="form-group ">
                <label for="city">
                    City/Town
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="city"
                    :required="newInvestorFlag"
                    value=""
                    v-model="investorDetails.city"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>


            <div class="form-group ">
                <label for="post-code">
                    Post Code
                </label>

                <input
                    type="text"
                    class="form-control"
                    name="post-code"
                    :required="newInvestorFlag"
                    value=""
                    v-model="investorDetails.postcode"
                    :readonly="!newInvestorFlag"
                    autocomplete="off"
                    aria-autocomplete="none"
                >
            </div>

            <div class="form-group ">
                <label for="country">
                    Country
                </label>

                <select id="countryList"
                        class="form-control"
                        name="country"
                        v-model="investorDetails.country"
                        autocomplete="off"
                        required
                >
                    <option value="">Select Country</option>
                    <option v-for="country in countryList" :value="country.value" :key="country.id">
                        {{ country.name }}
                    </option>
                </select>
            </div>


            <div class="form-group investment-application-navigation-controls">
                <button type="button" class="button" @click.stop="previous()">
                    Previous
                </button>

                <button type="submit" class="button button-primary">
                    <span>Next</span>
                </button>
            </div>
        </form>
    </section>
</template>

<style scoped>
    button[type="submit"] {
        margin-right: 0 !important;
    }
</style>
